export const isZipCodeValid = (value, maxLength, minLength, isLocaleEn = false) =>
    !(!isLocaleEn && (value.length > (maxLength || 5) || value.length < (minLength || 5)));
